import * as APITypes from "~/API";

export function financeInventoryHref(
  entityType: APITypes.EntityType | undefined,
  entityID: string,
): string {
  if (entityType === APITypes.EntityType.Parcel) {
    return `/parcel/${entityID}`;
  }
  return `/unit/${entityID}`;
}

export function financeInventoryKindLabel(
  entityType: APITypes.EntityType | undefined,
  t: (key: string) => string,
): string {
  if (entityType === APITypes.EntityType.Parcel) {
    return t("Parcel");
  }
  return t("Unit");
}
